import React from "react";

export default () => {
  return (
    <div>
      <footer className="my-2 px-3">
        <p className="mb-0 text-center text-lg-start"><small>
          &#169; 2025 - 2026, Blockcube Technology Pvt. Ltd. All rights reserved.
        </small></p>
      </footer>
    </div>
  );
};
